import React, { useState, useEffect } from "react";
import axios from "axios";
import ReactSession from "react-client-session/dist/ReactSession";
import Post from "./Post.js";
import PostForm from "./PostForm.js";

import { useLocation } from "@reach/router"
import * as queryString from 'query-string';


const Posts = (props) => {
  const location_data = queryString.parse(useLocation().search);
  const { hall, x, y, z } = location_data;

  const submitLabel = (location_data && location_data.hall) ? `Post to ${hall}` : "Post";

  const loggedIn = ReactSession.get("username") !== undefined;

  const [wantToMakePost, setWantToMakePost] = useState(false);
  const [backendPosts, setBackendPosts] = useState([]);
  const rootPosts = backendPosts.filter(
    (backendPost) => backendPost.parentId === undefined
  );

  if(loggedIn && !wantToMakePost && (x !== undefined || y !== undefined || z !== undefined)) {
    setWantToMakePost(true);
  }

  const fetchPosts = () => {
    fetch("/api/posts")
      .then((data) => {
        if (data.ok) {
          return data.json();
        }
      })
      .then((jsonData) =>
        setBackendPosts(
          jsonData.sort(
            (a, b) =>
              new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
          )
        )
      );
  };

  const addPost = async (content, parentId) => {
    //Generating random id while data is retrived because it will be reset anyways. Otherwise it sets to undefined and makes every post a reply to the new post...
    let newPost = {
      body: content,
      userId: ReactSession.get("userId"),
      username: ReactSession.get("username"),
      parentId: undefined,
      createdAt: new Date().toISOString(),
      img: ReactSession.get("userImg"),
      location_data: location_data || { x: 0, y: 0, z: 0, hall: "none" },
    };
    axios
      .post("/api/create", newPost)
      .then((res) =>
        setBackendPosts([{ ...newPost, _id: res._id }, ...backendPosts])
      );
  };

  const editPost = (postId, text) => {
    axios.post("/api/edit", { _id: postId, body: text }).then((res) => {
      const updatedBackendPosts = backendPosts.map(p => {
        if (p._id === postId) {
          return { ...p, body: text }
        }
        return p;
      })
      setBackendPosts(updatedBackendPosts);
    });
  };

  const deletePost = (postId) => {
    if (window.confirm("Are you sure you want to delete your post?")) {
      axios.post("/api/delete", { postId: postId });
      setBackendPosts(backendPosts.filter((post) => post._id !== postId));
    }
  };

  useEffect(fetchPosts, []);

  return (
    <div className="posts h-full overflow-y-auto">
      {loggedIn ? (
        <div>
          <div className="flex justify-between mx-36">
            <div className="flex-col flex-grow text-white text-5xl p-2">Gallery</div>
            <div
              className="shadow- flex-shrink inline-block rounded-full text-xl align-text-middle px-5 py-2 my-auto font-bold drop-shadow-2xl cursor-pointer 
                      bg-red-400 text-gray-900 hover:bg-red-300 border border-red-900/50"
              onClick={() => setWantToMakePost(!wantToMakePost)}
            >
              {wantToMakePost ? "Hide Post Form" : "Make Post"}
            </div>
          </div>
          <div>
            {wantToMakePost ? (
              <div className="flex-wrap">
                <PostForm submitLabel={submitLabel} handleSubmit={addPost} />
              </div>
            ) : (
              <></>
            )}{" "}
          </div>
        </div>
      ) : (
        <div class="w-full text-center py-2">
          <span class="text-center px-2 py-1 rounded bg-red-500 text-white">
            You must be logged in to post
          </span>
        </div>
      )}
      <div className="grid 2xl:grid-cols-5 xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 mx-20 h-auto mt-10">
        {rootPosts.map((rootPost) => (
          <Post
            key={rootPost._id}
            pfp={rootPost.img}
            post={rootPost}
            loc={rootPost.location_data}
            replies={[]}
            currentUserId={props.currentUserId}
            deletePost={deletePost}
            editPost={editPost}
          />
        ))}
      </div>
      <div className="h-32 dummy-div"></div>
    </div>
  );
};

export default Posts;
